import script from "./AuraFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuraFilters.vue?vue&type=script&lang=ts&setup=true"

import "./AuraFilters.vue?vue&type=style&index=0&id=5aab1184&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aab1184"]])

export default __exports__